export default __webpack_public_path__ + "static/media/blog-31-image-1.77389184.jpg";